import { AxiosResponse } from 'axios';
import instance from '../../api/instance';

export type GetTimezones = () => Promise<AxiosResponse<string[]>>;

export const getTimezones: GetTimezones = async () => {
  return instance.get(`timezones`).catch(e => e.response as never);
};
